module.exports = __webpack_public_path__ + "static/media/empty-state-graph.c4483b66.png";